import { render } from "./MainSearchInput.vue?vue&type=template&id=5bb79b28&scoped=true"
import script from "./MainSearchInput.vue?vue&type=script&lang=js"
export * from "./MainSearchInput.vue?vue&type=script&lang=js"

import "./MainSearchInput.vue?vue&type=style&index=0&id=5bb79b28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb79b28"]])

export default __exports__